const ENV = import.meta.env.VITE_APP_NODE_ENV;

const FAVICON_MAP: Record<string, string> = {
  develop: '/favicon-dev.svg',
  staging: '/favicon-staging.svg',
};

const favicon = document.getElementById('favicon') as HTMLLinkElement | null;
if (favicon && FAVICON_MAP[ENV]) {
  favicon.href = FAVICON_MAP[ENV];
}
